import { render, staticRenderFns } from "./EditorRelateArray.vue?vue&type=template&id=93288a26&"
import script from "./EditorRelateArray.vue?vue&type=script&lang=js&"
export * from "./EditorRelateArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports